module.exports = __webpack_public_path__ + "img/6.7f37063f.png";